module.exports = __webpack_public_path__ + "media/recipes/99-d3a85bbf.png";